/* eslint-disable no-extend-native */
/* eslint-disable no-loop-func */
import { isEmpty, isNumber, uniqBy } from "lodash";
import moment from "moment";
import _ from "lodash";

export const removeAccents = (str) => {
    if (!str) return "";
    return str
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/đ/g, "d")
        .replace(/Đ/g, "D");
};

export const convertCode = (data) => {
    let code = {};
    data.map((element) => {
        code[element.code] = element;
    });
    return code;
};

export const buildTreeMenu = (data) => {
    let map = new Map(data.map((v) => [v.code, v]));

    for (let value of map.values()) {
        value.link = value.path;

        if (value.parent_code && map.get(value.parent_code)) {
            let parent = map.get(value.parent_code);
            value.link = `${value.link}`;
            parent.children = parent.children ? [...parent.children, value] : [value];
        }
    }
    const tree = data.filter((v) => !v.parent_code);
    return tree;
};

export const buildTree = (data) => {
    let map = new Map(data.map((v) => [v.code, v]));
    for (let value of map.values()) {
        if (value.parent_code && map.get(value.parent_code)) {
            let parent = map.get(value.parent_code);
            parent.children = parent.children ? [...parent.children, value] : [value];
        }
    }
    const tree = data.filter((v) => !v.parent_code || !map.get(v.parent_code));
    return tree;
};

export function convertToQuery(param) {
    return (
        "" +
        Object.keys(param)
            .map(function (key) {
                return encodeURIComponent(key) + "==" + encodeURIComponent(param[key]);
            })
            .join(";")
    );
}

export function convertParamsToQuery(param) {
    return (
        "?" +
        Object.keys(param)
            .map(function (key) {
                return encodeURIComponent(key) + "=" + encodeURIComponent(param[key]);
            })
            .join("&")
    );
}

export function checkKeyNull(obj) {
    for (let v in obj) {
        switch (typeof obj[v]) {
            case "number":
                if (isNaN(obj[v]) || obj[v] == null) delete obj[v];
                break;
            case "string":
                if (isEmpty(obj[v])) delete obj[v];
                else obj[v] = obj[v].trim();
                break;
            default:
                if (obj[v] == null) delete obj[v];
                break;
        }
    }
    return obj;
}

export function removeDuplitcate(med) {
    const arr = [];
    med.reduce((acc, curr) => {
        if (acc.indexOf(curr.position) === -1) {
            acc.push(curr.position);
            arr.push(curr);
        }
        return acc;
    }, []);

    return arr;
}

export const isAllItemOnPageChecked = (parent, child, key) => {
    const tempParent = parent.filter((item) => item !== undefined);

    return !isEmpty(child) && child.every((elm) => tempParent.findIndex((i) => i[key] === elm[key]) > -1);
};

export const removeCheckAllItems = (parent, child, key) => {
    return parent.filter((elm) => child.findIndex((i) => i[key] === elm[key]) < 0);
};

export const addAllItemOfPage = (targetArray, arrayForAdd, key) => {
    return uniqBy([...arrayForAdd, ...targetArray], key);
};

export const addAnItems = (targetArray, itemForAdd, key) => {
    const arrayAfterFilterItem = targetArray.filter((elm) => elm[key] !== itemForAdd[key]);
    if (arrayAfterFilterItem.length === targetArray.length) {
        arrayAfterFilterItem.push(itemForAdd);
    }
    return arrayAfterFilterItem;
};

export const isItemChecked = (parent, itemForCheck, key) => {
    return Boolean(parent.filter((item) => item !== undefined).filter((elm) => elm[key] === itemForCheck[key]).length > 0);
};

export const selectedItem = (parent, itemForSelect) => {
    return uniqBy([...parent, ...[itemForSelect]]);
};

String.prototype.generatePassword = function () {
    return Array(parseInt(this))
        .fill("0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz!@#$%^&*()")
        .map((x) => x[Math.floor((crypto.getRandomValues(new Uint32Array(1))[0] / (0xffffffff + 1)) * x.length)])
        .join("");
};

export const generatePassword = (length) => {
    const strongRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\!\@\#\$\%\&\*\(\)\_\+\-\=\[\]\|\,\.\/\?\>\<])[A-Za-z\d\!\@\#\$\%\&\*\(\)\_\+\-\=\[\]\|\,\.\/\?\>\<]{8,15}$/;
    let pass = length.toString().generatePassword();
    while (!strongRegex.test(pass)) {
        pass = length.toString().generatePassword();
    }
    return pass;
};

export const convertObjectToQuery = (obj, char = "==") => {
    Object.keys(obj || {}).forEach((key) => {
        const value = obj[key];
        if (isEmpty(value) && !isNumber(value)) {
            delete obj[key];
        }
    });

    const arr = Object.keys(obj || {}).map((key) => {
        const value = obj[key].toString().trim();
        if (["ostar"].includes(key) || char !== "==") {
            return `${key}${char}${value}`;
        }
        if (/=in$/.test(key)) {
            return `${key}=(${value})`;
        }
        if (/=$/.test(key)) {
            return `${key}=${value}`;
        }

        return `${key}${char}"*${value}*"`;
    });
    return arr.join(";");
};

export const convertObjectToUrl = (obj) => {
    Object.keys(obj || {}).forEach((key) => {
        const value = obj[key];
        if (isEmpty(value) && !isNumber(value)) {
            delete obj[key];
        }
    });

    const arr = Object.keys(obj || {}).map((key) => {
        const value = obj[key];
        if (key === "sort" || key === "sorts") {
            return `${key}=${convertObjectToQuery(value, ":")}`;
        }
        if (/=in$/.test(key)) {
            return `${key}=(${value})`;
        }
        if (_.isObject(value)) {
            return `${key}=${convertObjectToQuery(value)}`;
        }
        return `${key}=${value.toString().trim()}`;
    });
    return "?" + arr.join("&");
};

export const trimObject = (obj) => {
    const trimed = JSON.stringify(obj, (key, value) => {
        if (typeof value === "string") {
            return value.trim();
        }
        return value;
    });
    return JSON.parse(trimed);
};

export const boolObject = (obj) => {
    const trimed = JSON.stringify(obj, (key, value) => {
        if (typeof value === "boolean") {
            if (value) {
                return "true";
            } else {
                return "false";
            }
        }
        return value;
    });
    return JSON.parse(trimed);
};

export const stringObject = (obj) => {
    const trimed = JSON.stringify(obj, (key, value) => {
        if (typeof value === "string") {
            if (value === "true") {
                return true;
            }
            if (value === "false") {
                return false;
            }
            return value;
        }
        return value;
    });
    return JSON.parse(trimed);
};

const base64ToUint8Array = (string) => {
    var raw = window.atob(string);
    var rawLength = raw.length;
    var array = new Uint8Array(new ArrayBuffer(rawLength));
    for (var i = 0; i < rawLength; i += 1) {
        array[i] = raw.charCodeAt(i);
    }
    return array;
};

export const downloadExcel = (body) => {
    const blob = new Blob([base64ToUint8Array(body)], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    let fileName = "danh-sach-loi";
    let extension = "xlsx";

    const url = window.URL.createObjectURL(blob);
    let a = window.document.createElement("a");
    a.href = url;
    a.target = "_blank";

    a.download = `${fileName}.${extension}`;
    document.body.appendChild(a);
    a.click();
};

export const removeVietnameseTones = (str) => {
    if (str === undefined || str === null) {
        return "";
    }
    str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
    str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
    str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
    str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
    str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
    str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
    str = str.replace(/đ/g, "d");
    str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, "A");
    str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, "E");
    str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, "I");
    str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, "O");
    str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, "U");
    str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, "Y");
    str = str.replace(/Đ/g, "D");
    // Some system encode vietnamese combining accent as individual utf-8 characters
    // Một vài bộ encode coi các dấu mũ, dấu chữ như một kí tự riêng biệt nên thêm hai dòng này
    str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, ""); // ̀ ́ ̃ ̉ ̣  huyền, sắc, ngã, hỏi, nặng
    str = str.replace(/\u02C6|\u0306|\u031B/g, ""); // ˆ ̆ ̛  Â, Ê, Ă, Ơ, Ư
    // Remove extra spaces
    // Bỏ các khoảng trắng liền nhau
    str = str.replace(/ + /g, " ");
    str = str.trim();
    // Remove punctuations
    // Bỏ dấu câu, kí tự đặc biệt
    str = str.replace(/!|@|%|\^|\*|\(|\)|\+|\=|\<|\>|\?|\/|,|\.|\:|\;|\'|\"|\&|\#|\[|\]|~|\$|_|`|-|{|}|\||\\/g, " ");
    return str;
};

export const convertToFormSelect = (list, fieldForLabel, fieldForValue) => {
    return [
        ...list.reduce((arr, el) => {
            return [
                ...arr,
                {
                    ...el,
                    label: el[fieldForLabel] || "None",
                    value: el[fieldForValue] || "",
                },
            ];
        }, []),
    ];
};

const SUCCESS_STATUS = [200, 201, 202, 203, 204];

export const callAPIPaging = (props) => {
    const { response, onSuccess, onError, size: limit } = props;
    if (SUCCESS_STATUS.includes(response?.code || response?.status)) {
        const returnData = {
            data: response?.data,
            meta: { totalPage: 0, totalItems: 0 },
        };
        if (response.headers["x-total-count"]) {
            const allDataCount = response.headers["x-total-count"];
            returnData.meta.totalItems = allDataCount;
            if (Number(allDataCount) / Number(limit) > Math.round(Number(allDataCount) / Number(limit))) {
                returnData.meta.totalPage = Math.round(Number(allDataCount) / Number(limit)) + 1;
            } else {
                returnData.meta.totalPage = Math.round(Number(allDataCount) / Number(limit));
            }
        }
        onSuccess(returnData);
        return;
    }
    onError({ data: response?.data, statusText: response?.statusText });
};
function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export const removeMiddleSpaceStr = (str, type = "middle") => {
    let string = capitalizeFirstLetter(str.trim());

    if (type === "all") return string.replace(/ +/g, "");

    return string.replace(/ +/g, " ");
};

export const avoidSpecialChar = (e, type = "num") => {
    let regStr =
        type === "notNum"
            ? "^[a-zA-ZÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂẾưăạảấầẩẫậắằẳẵặẹẻẽềềểếỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ sW|]+$"
            : "^[0-9a-zA-ZÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂẾưăạảấầẩẫậắằẳẵặẹẻẽềềểếỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ sW|]+$";

    let regex = new RegExp(regStr);
    let key = String.fromCharCode(!e.charCode ? e.which : e.charCode);

    if (!regex.test(key)) {
        e.preventDefault();
        return false;
    }
};

export const convertToLocaleString = (numb) => {
    return numb?.toLocaleString();
};

export function calcItemStart(page = 1, size = 10) {
    return (page - 1) * size;
}

export const convertBase64 = (val) => {
    try {
        return `data:image/png;base64,${val}`;
    } catch (error) {
        return "";
    }
};

export const subDiaChinhNumb = 22132;
export function List_to_tree(list) {
    var map = {},
        node,
        roots = [],
        i;

    for (i = 0; i < list.length; i += 1) {
        map[list[i].diaChinhId] = i;
        list[i].children = [];
    }

    for (i = 0; i < list.length; i += 1) {
        node = list[i];

        // if (node.parentId == node.diaChinhId) {
        //   node.diaChinhId = node.diaChinhId + 9999;
        // }
        if (node.parentId != "0") {
            //child
            list[map[node.parentId]]?.children.push(node);
        } else {
            //parent
            roots.push(node);
        }
    }
    return roots;
}

export function convertTimeStamp(timeStamp) {
    if (!timeStamp) return "";

    const dateFormat = new Date(+timeStamp);

    return dateFormat.getDate() + "-" + (dateFormat.getMonth() + 1) + "-" + dateFormat.getFullYear() + " " + dateFormat.getHours() + ":" + dateFormat.getMinutes() + ":" + dateFormat.getSeconds();
}

export const convertUrl = (url, key, value) => {
    if (!url.includes(key)) return url;
    const urlSlice = url.slice(0, url.indexOf(key));
    return urlSlice.concat(key, `=="${value}"`);
};

export function convertMenu(list = []) {
    if (list?.length === 0) return [];
    const convert = list.reduce(
        (acc, curr) => {
            const initialItem = {
                key: curr.code,
                parentCode: curr.parentCode,
                title: curr.name,
                path: curr.path,
                children: [],
            };
            if (curr.parentCode === null) {
                const item = {
                    ...initialItem,
                };
                acc.sort = [...acc.sort, item];
            } else {
                const item = {
                    ...initialItem,
                };
                acc.remove = [...acc.remove, item];
            }
            return acc;
        },
        {
            sort: [],
            remove: [],
        }
    );
    const result = convert.sort.reduce((acc, curr) => {
        const items = convert.remove.filter((item) => item.parentCode === curr.key);

        const _items = convert.remove.filter((item) => item.parentCode !== curr.code);
        convert.remove = [..._items];

        const child = convert.remove.filter((c) => {
            const result = items.some((i) => i.key === c.parentCode);
            return result;
        });

        const _child = convert.remove.filter((c) => {
            const result = child.some((i) => i.key !== c.parentCode);
            return result;
        });

        const reItems = items.map((item) => {
            if (child.length && item.key === child[0]?.parentCode) {
                return {
                    ...item,
                    children: child,
                };
            }
            return item;
        });

        const result = {
            ...curr,
            children: reItems,
        };

        if (_child.length >= convert.remove.length) {
            convert.remove = [];
        }

        acc = [...acc, result];
        return acc;
    }, []);
    return result;
}

export const convertOjectNotValue = (object) => {
    const result = Object.assign(Object.fromEntries(Object.entries(object).filter(([_, v]) => v !== "" && v !== undefined && v !== null)));
    return result;
};

export const handleLanguageChange = (input, option) => removeVietnameseTones(input.children).toLowerCase().indexOf(removeVietnameseTones(option)) >= 0;

export const handleCustomNameChange = (value) => {
    const nameSplit = value.trim().split(" ");
    const result = nameSplit.map((i) => i.substring(0, 1).toUpperCase() + i.substring(1).toLowerCase()).join(" ");

    return result;
};
